import { createContext, useContext, useState } from 'react'

const DeviceContext = createContext(null)

export const useDevice = () => {
  const context = useContext(DeviceContext)
  if (context === undefined || context === null) {
    throw new Error('useDevice must be used within a DeviceProvider')
  }
  return context
}

export const DeviceProvider = ({ children }) => {
  const [selectedDevice, setSelectedDevice] = useState(
    JSON.parse(localStorage.getItem('selectedDevice')) || {},
  )

  const handleSetSelectedDevice = (device) => {
    localStorage.setItem('selectedDevice', JSON.stringify(device))
    setSelectedDevice(device)
  }

  const value = {
    selectedDevice,
    setSelectedDevice: handleSetSelectedDevice,
  }

  if (!value) {
    throw new Error('DeviceProvider value is undefined')
  }

  return (
    <DeviceContext.Provider value={value}>{children}</DeviceContext.Provider>
  )
}
